import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    modalHeader: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    filterSection: {
        justifyContent: "space-between",
        alignItems: "center"
    },
    rowContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        borderStyle: "solid",
        width: "100%"
    },
    modalOverlay: {
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    emptyContainer: {
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        flex: 1
    },
    switchContainer: {
        justifyContent: "center",
        alignItems: "center"
    },
    container: {
        flexDirection: "column",
        width: "100%",
        flex: 1
    },
    rowLeftContent: {
        flexDirection: "column",
        flex: 1
    },
    listContainer: {
        flexDirection: "column",
        width: "100%"
    },
    rowHeader: {
        flexDirection: "row",
        alignItems: "center"
    },
    rowSubtitle: {
        flexDirection: "row",
        alignItems: "center"
    },
    rowRightContent: {
        flexDirection: "row",
        alignItems: "center"
    },
    emptyText: {
        textAlign: "center"
    },
    switchTitle: {
        lineHeight: 20
    },
    searchContainer: {
        flex: 1
    },
    rowTitle: {
        flexShrink: 1
    }
});

export default stylesheet;
